var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup481396(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.426172 10.4099C0.425703 12.0828 0.868203 13.7162 1.70961 15.156L0.345703 20.0752L5.44195 18.7552C6.85151 19.5132 8.43081 19.9104 10.0357 19.9105H10.0399C15.338 19.9105 19.6507 15.6518 19.653 10.4174C19.654 7.88092 18.6549 5.49579 16.8398 3.70135C15.0249 1.90707 12.6113 0.918394 10.0395 0.917236C4.74086 0.917236 0.428438 5.17568 0.42625 10.4099",
    fill: "url(#paint0_linear_923_8701)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0835938 10.4069C0.0830469 12.14 0.541406 13.8318 1.41281 15.3231L0 20.4187L5.27898 19.0514C6.73352 19.8348 8.37117 20.2478 10.0376 20.2484H10.0419C15.53 20.2484 19.9977 15.8366 20 10.4148C20.0009 7.78715 18.9659 5.31628 17.0859 3.45755C15.2057 1.59906 12.7057 0.574811 10.0419 0.57373C4.55281 0.57373 0.0857813 4.98497 0.0835938 10.4069ZM3.22742 15.0663L3.03031 14.7572C2.20172 13.4558 1.76437 11.9518 1.765 10.4075C1.76672 5.90095 5.47953 2.23451 10.045 2.23451C12.2559 2.23543 14.3337 3.08681 15.8966 4.63152C17.4593 6.17638 18.3192 8.22997 18.3187 10.4141C18.3166 14.9207 14.6037 18.5876 10.0419 18.5876H10.0386C8.5532 18.5868 7.09641 18.1928 5.82594 17.4481L5.52359 17.271L2.39094 18.0823L3.22742 15.0663Z",
    fill: "url(#paint1_linear_923_8701)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55352 6.29637C7.36711 5.88712 7.17094 5.87886 6.99367 5.87169C6.84852 5.86551 6.68258 5.86597 6.5168 5.86597C6.35086 5.86597 6.08125 5.92764 5.85336 6.17343C5.62523 6.41946 4.98242 7.01401 4.98242 8.22324C4.98242 9.43248 5.87406 10.6012 5.99836 10.7653C6.12281 10.9292 7.71969 13.4901 10.2487 14.4753C12.3506 15.294 12.7784 15.1312 13.2345 15.0901C13.6908 15.0492 14.7067 14.4958 14.914 13.9218C15.1214 13.348 15.1214 12.8561 15.0592 12.7533C14.997 12.6508 14.8311 12.5893 14.5823 12.4665C14.3334 12.3436 13.1101 11.7489 12.882 11.6669C12.6539 11.5849 12.488 11.544 12.3221 11.7901C12.1562 12.0359 11.6797 12.5893 11.5345 12.7533C11.3894 12.9176 11.2441 12.938 10.9954 12.8151C10.7464 12.6917 9.94508 12.4325 8.99438 11.5953C8.25469 10.9438 7.75531 10.1392 7.61016 9.89312C7.465 9.6474 7.59461 9.5142 7.71938 9.39173C7.83117 9.2816 7.96828 9.10472 8.09281 8.96125C8.21688 8.81771 8.25828 8.7153 8.34125 8.55138C8.4243 8.38731 8.38273 8.24377 8.32063 8.12083C8.25828 7.9979 7.77477 6.78233 7.55352 6.29637Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_923_8701",
    x1: 965.709,
    y1: 1916.71,
    x2: 965.709,
    y2: 0.917236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_923_8701",
    x1: 1000,
    y1: 1985.07,
    x2: 1000,
    y2: 0.57373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup481396);
export default __webpack_public_path__ + "static/media/Group 481396.a1121dff023a874353e40862e76d051e.svg";
export { ForwardRef as ReactComponent };